import { motion } from "framer-motion";
import React from "react";
import { fadeIn } from "../variants";

const About = () => {
  return (
    <section id="about" className="section">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row lg:gap-x-20 gap-y-10 lg:gap-y-0 lg:items-center h-screen">
          {/* Text */}
          <motion.div
            variants={fadeIn("left", "0.5")}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1"
          >
            <h2 className="h2 text-accent">About Me</h2>
            <h3 className="h3 mb-4">
              Hello, my name is Gabriel, and I've been working as a Software
              Engineer for more than 3 years.
            </h3>
            <p className="mb-6">
              I currently work as a Software Engineer, with experience
              over the entire software development cycle. I use technologies like
              Javascript, Typescript, React, Next, and NodeJS to create web
              applications. Besides the technical knowledge in these
              technologies, I have developed various real projects that serve
              thousands of clients. My goal is to develop projects that
              transform and impact millions of people.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
